<template>
    <modal :modal-id="modalId"
           :class="modalBodyClass"
                     :title="modalTitle"
                     :preloader="preloader"
                     @submit="submit"
                     @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>

            <div class="modal-sidebar">

                <div class="modal-contentbox-tabs tab-start" :class="this.inputs.timeline_state > 5 ? '' : 'tab-indent'">
                    <button class="tab" :class="this.currentTab == 'main' ? 'active' : ''" @click.prevent="showTab('main')">
                        <app-icon :name="'book-open'" width="25" height="25"/>
                        <span>{{ $t('course') }}</span>
                    </button>
                    <button class="tab" :class="this.currentTab == 'attendees' ? 'active' : ''" @click.prevent="showTab('attendees')">
                        <app-icon :name="'user'" width="25" height="25"/>
                        <span>{{ $t('course_atendees') }}</span>
                    </button>
                    <button class="tab" style="display: none !important;" :class="this.currentTab == 'results' ? 'active' : ''" @click.prevent="showTab('results')">
                        <app-icon :name="'bar-chart'" width="25" height="25"/>
                        <span>{{ $t('results') }}</span>
                    </button>
                </div>

                <div v-if="selectedUrl" class="mobile-action-footer">

                    <div class="d-none d-md-block">
                        <a href=""
                           class="action-option"
                           @click.prevent="closeModalAndOpen('rejection')">
                            <div class="btn btn-secondary btn-sm btn-circle btn-circle-xs">
                            <app-icon :name="'trash'" width="18" height="18"/>
                            </div>
                            <span class="red">{{ $t('delete') }}</span>
                        </a>
                    </div>

                </div>

            </div>


            <form id="modal-contentbox-start"  class="col-md-9 pl-2 pt-0 pr-0 mb-1 modal-contentbox-body"
                  :class="{'loading-opacity': preloader}"
                  ref="form" :data-url='selectedUrl ? `admin/app/courses/${inputs.id}` : `admin/app/courses`'>



                    <div v-show="this.currentTab == 'main'" class="modal-contentbox-row pr-0">

                        <div class="form-group row align-items-center pl-0 pr-0 mb-30 col-md-12">
                            <label for="inputs_name" class="col-sm-12">
                                {{ $t('course_name') }}
                            </label>
                            <app-input id="inputs_name"
                                       class="col-sm-12 pr-0 mb-4"
                                       type="text"
                                       v-model="inputs.name"
                                       :placeholder="$t('text_type_input')"
                                       :required="true"/>


                            <label for="inputs_label" class="col-sm-12">
                                {{ $t('one_tag') }}
                            </label>
                            <app-input id="inputs_label"
                                       class="col-sm-12 pr-0 mb-4"
                                       type="text"
                                       v-model="inputs.label"
                                       :placeholder="$t('text_type_input')"/>


                            <label for="inputs_timeline_state_course" class="col-sm-12 mt-0">
                                {{ $t('timeline_course_date') }} <app-icon :name="'clock'" width="20" height="20" class="mt-0"/>
                            </label>
                            <app-input id="inputs_timeline_state_course"
                                       class="large-input col-sm-12 pr-0 mb-3"
                                       type="select"
                                       :title="$t('timeline_state')"
                                       v-model="inputs.timeline_state"
                                       :list="timelineStatesLists"
                                       :required="true"/>


                            <div v-if="inputs.timeline_state >= 13" class="row col-12 mb-4">
                                <app-input id="inputs_deadline_month_course"
                                            class="col-sm-2 pr-0"
                                            type="number"
                                            :minNumber="0"
                                            v-model="inputs.deadline_month"/>
                                <label for="inputs_deadline_month_course" class="col-sm-10 mt-0 pt-md-2 mb-4">
                                    {{ $t('deadline_month') }}
                                </label>
                            </div>



                            <div class="col-12">
                                <label for="inputs_text" class="col-sm-12 mt-2 pl-0 ml-0">
                                    {{ $t('upload_course') }}
                                </label>

                                <app-course-attachment :table-id="tableFileId" :course-id='selectedUrl ? selectedUrl.replace(/\D/g, "") : temporaryId' class="loading-hidden"></app-course-attachment>
                                <app-attachment-upload-form :table-id="tableFileId" :course-id='selectedUrl ? selectedUrl.replace(/\D/g, "") : temporaryId'></app-attachment-upload-form>

                            </div>
                        </div>

                        <div class="form-group row align-items-center">

                            <label for="inputs_text" class="col-sm-12 mb-0">
                                {{ $t('course_content') }}
                            </label>

                            <app-overlay-loader v-if="editorPreloader"/>
                            <app-input v-if="finishedGetData" id="inputs_text"
                                       class="col-sm-12"
                                       type="text-editor"
                                       v-model="inputs.body"
                                       :placeholder="$t('text_type_input')"
                                       />
                            <app-input v-if="editorPreloader"
                                       id="inputs_text_blind"
                                       class="col-sm-12"
                                       :class="{'loading-opacity': editorPreloader}"
                                       type="textarea"/>



                        </div>
                        <div class="form-group row align-items-center mb-2">
                            <label for="inputs_note" class="col-sm-12 mb-0">
                                {{ $t('course_note') }} {{ $t('(internal)') }}
                            </label>
                            <app-input id="inputs_note"
                                       class="col-sm-12"
                                       :class="inputs.note ? 'note_added' : ''"
                                       type="textarea"
                                       v-model="inputs.note"
                                       :placeholder="$t('text_type_input')"
                                       />
                        </div>


                    </div>



                    <div v-show="this.currentTab == 'attendees'" class="modal-contentbox-row pr-0">

                        <div v-if="this.inputs.status !== 4" class="form-group row align-items-center pl-0 pr-0 mb-30 col-md-12">
                            <label for="inputs_status" class="col-sm-12">
                                {{ $t('active_courses') }} <app-icon :name="'eye-off'" width="20" height="20" class="mt-0"/>
                            </label>
                            <app-input id="inputs_status"
                                    class="col-sm-12"
                                    type="select"
                                    v-model="inputs.status"
                                     :list="statusLists"/>

                        </div>
                        <hr>
                        <div class="form-group row align-items-center pl-0 pr-0 mb-30 col-md-12">
                            <label for="inputs_status" class="col-sm-12">
                                {{ $t('course_atendees') }}
                            </label>

                            <div v-if="this.atendeeOptions.length !== 0" class="note note-info row ml-2 p-4 col-sm-12">
                                <div class="col-md-1">
                                    <app-icon :name="'users'" width="30" height="30"/>
                                </div>
                                <div class="col-md-11">
                                    <b>{{ $t('no_of_users_that_will_attend') }} {{ atendeeOptions.total }}
                                            <span v-if="atendeeOptions.total < 5">{{ $t('people_plural_3rd') }}</span>
                                            <span v-else="atendeeOptions.total > 5">{{ $t('people_plural_2nd') }}</span>
                                            ({{ Math.round(100*(atendeeOptions.total/candidateOptions.length) * 10) / 10 }} {{ $t('percent_of_company_that_will_attend') }}) </b>
                                </div>
                            </div>

                            <label for="inputs_candidate_id" class="col-sm-12 mt-3">
                                {{ $t('course_atendees_person') }}
                            </label>
                            <app-input id="inputs_candidate_id"
                                        class="col-sm-12"
                                        type="multi-select"
                                        :list="candidateOptions"
                                        :isAnimatedDropdown="true"
                                        v-model="inputs.candidate_id"
                                        @input="getAttandees"/>

                            <label for="inputs_job_id" class="col-sm-12 mt-4">
                                {{ $t('course_atendees_jobs') }}
                            </label>
                            <app-input id="inputs_job_id"
                                        class="col-sm-12"
                                        type="multi-select"
                                        :list="jobOptions"
                                        :isAnimatedDropdown="true"
                                        v-model="inputs.job_id"
                                        @input="getAttandees"/>

                            <label for="inputs_tag_id" class="col-sm-12 mt-4">
                                {{ $t('course_atendees_tags') }}
                            </label>
                            <div class="col-sm-12">
                            <app-tag-manager
                                :tags="tags"
                                v-model="inputs.tag_id"
                                :list="tagOptions"
                                list-value-field="value"
                                @attachTag="attachTag"
                                @detachTag="detachTag"/>
                            </div>




                        </div>


                    </div>
                    <div v-show="this.currentTab == 'results'" class="modal-contentbox-row pr-0">
                        <div v-if="this.atendeeOptions">
                            <div v-if="this.selectedUrl" class="col-12 col-md-6 p-0 float-left form-group row align-items-center mb-2">
                                <label for="inputs_finished" class="col-sm-12">
                                    {{ $t('already_gradueted') }} <div v-if="gradueteOptions.total" class="btn btn-primary btn-sm badge-counter">{{ gradueteOptions.total }}</div>
                                </label>
                                <div class="mb-0 col-sm-12 mb-5">
                                    <app-employee-list :employees="this.gradueteOptions ? this.gradueteOptions : ''" class="loading-hidden"></app-employee-list>
                                </div>

                            </div>
                            <div class="col-12 col-md-6 p-0 float-left form-group row align-items-center mb-2">
                                <label for="inputs_finished" class="col-sm-12">
                                    {{ $t('future_atendees') }} <div v-if="atendeeOptions.total" class="btn btn-primary btn-sm badge-counter">{{ atendeeOptions.total }}</div>
                                </label>
                                <div class="mb-0 col-sm-12 mb-5">
                                    <app-employee-list :employees="this.atendeeOptions ? this.atendeeOptions : ''" class="loading-hidden"></app-employee-list>
                                </div>

                            </div>
                        </div>

                        <div class="text-center">
                            <hr class=" mt-5"><br><br>
                            <app-icon :name="'edit'" class="mr-4" width="16" height="16"/><br>
                            <a href="../onboarding/quiz" target="_blank">Přidejte stejným účastníkům test </a> ať si můžete vyhodnotit znalosti

                        </div>


                        <div style="display:none;">
                            <hr>
                            <div class="col-12 col-md-12 p-0 float-left form-group row align-items-center mb-0">
                                <label for="inputs_finished" class="col-sm-12 mb-3">
                                    {{ $t('graduates_answers') }}
                                </label>


                                <div class="col-12">
                                        <div class="overlay-locked pt-5 mt-3">
                                            <app-icon :name="'clock'" class="mr-4" width="40" height="40"/><br>
                                            <div class="offset-md-2 col-md-8 mt-4">
                                                <h5><b>Čeká se na výsledky</b></h5>
                                                Zde se objeví výsledky jakmile budete mít alespoň 1 absolventa<br><br>
                                            </div>

                                        </div>
                                        <div class="content-locked locked-group">
                                            <app-chart v-if="isActiveFinishedStats && isActiveFinishedStatsAndDisplayed" class="mb-primary"
                                                           type="dough-chart"
                                                           :width="300"
                                                           :height="160"
                                                           :labels="finishedStats.labels"
                                                           :data-sets="finishedStats.dataSet"/>
                                        </div>

                                </div>



                            </div>

                        </div>


                    </div>






                <br>
            </form>
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';
    import {ModalMixin} from "../../../../../Mixins/ModalMixin";

    export default {
        name: "AddModal",
        mixins: [FormMixin, ModalMixin],
        props: {
            tableId: String,
        },
        watch: {
            tags (val, oldVal) {
                if(this.finishedGetTag){
                    this.getAttandees();
                }

            },
        },
        data() {
            return {
                preloader: false,
                editorPreloader: false,
                finishedGetData: false,
                finishedGetJob: false,
                finishedGetCandidate: false,
                finishedGetTag: false,
                inputs: {
                    name: '',
                    attachment: '',
                    label: '',
                    job_id: [],
                    candidate_id: [],
                    tag_id: [],
                    status: 1,
                    timeline_state: 7,
                    deadline_month: '',

                    answer_1: 0,
                    answer_2: 0,
                    answer_3: 0,

                },

                selectedAction: 'body1',
                selectedId: '100',
                currentTab: 'main',
                tableFileId: 'file-table',

                job: 1,
                isNotePreselectionHidden: true,
                isNoteStatusHidden: true,
                jobOptions: [],
                candidateOptions: [],
                atendeeOptions: [],
                gradueteOptions: {
                    total: "0",
                },
                tags: [],
                tagOptions: [],
                statusLists: [
                    {id: 1, value: "Ano",},
                    {id: 2, value: "Ne, skrýt",},
                    {id: 3, value: "Ne, smazat",},
                ],
                answerLists: [
                    {id: '0', value: "Ano",},
                    {id: '1', value: "Ne",},
                ],
                timelineStatesLists: [
                    {id: '7', value: 'Před nástupem'},
                    {id: '8', value: 'První den'},
                    {id: '9', value: 'Zkušební doba'},
                    {id: '10', value: 'Zaměstnání'},
                    {id: '11', value: 'Povýšení'},
                    {id: '12', value: 'Mateřská'},
                    {id: '13', value: 'Offboarding'},
                ],

                courseFinishedBy: '',
                finishedStats: [],
                isActiveFinishedStats: false,
                isActiveFinishedStatsAndDisplayed: false,


                list: [
                    {
                        id: 'Beginner',
                        value: 'Beginner'
                    },
                    {
                        id: 'Intermediate',
                        value: 'Intermediate'
                    },
                    {
                        id: 'Professional',
                        value: 'Professional'
                    },
                    {
                        id: 'Master',
                        value: 'Master'
                    }
                ],


                educationLists: [
                    {id: '43', value: "Vysokoškolské vzdělání (doktorské)"},
                    {id: '42', value: "Vysokoškolské vzdělání (magisterské)"},
                    {id: '41', value: "Vysokoškolské vzdělání (bakalářské)"},
                    {id: '40', value: "Vysokoškolské vzdělání"},
                    {id: '30', value: "Vyšší odborné vzdělání"},
                    {id: '24', value: "Střední vzdělání s maturitní zkouškou"},
                    {id: '23', value: "Střední vzdělání s výučním listem"},
                    {id: '22', value: "Střední vzdělání (bez výučního listu a bez maturitní zkoušky)"},
                    {id: '21', value: "Střední odborné vzdělání"},
                    {id: '20', value: "Středoškolské vzdělání"},
                    {id: '10', value: "Základní vzdělání"},
                    {id: '0', value: "Vzdělání není podstatné"},
                ],
                modalId: 'add-edit-Modal',
                modalBodyClass: 'add-edit-modal',
                modalTitle: this.$t('add'),
                temporaryId: "0",
            }
        },
        created() {

            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.courseFinishedBy = 'Erik Dvořák';
                this.preloader = true;
            } else {
                this.finishedGetData = true;
            }

            if(this.selectedUrl === ''){
                this.temporaryId = Math.floor((Math.random() * 10000) + 900000).toString();
            }

        },
        mounted() {

            this.getJobs();
            this.getCandidates();
            this.getAttandees();
            this.getTags();
            this.getFinishedStats();

        },
        methods: {

            /**
             * Display
             * */

            showTab(tab) {
                this.currentTab = tab;
                document.getElementById("modal-contentbox-start").scrollIntoView();

                if(tab == "results"){
                    let _this = this;

                    setTimeout(function(){
                        _this.isActiveFinishedStatsAndDisplayed = true;
                    }, 300);
                }
            },


            /**
             * Modals
             * */

            closeModalAndOpen(modal) {
                this.inputs.status = 3;
                this.submit();
            },


            /**
             * Actions
             * */

            attachTag(tagId) {
                if(isNaN(tagId)){
                    // console.log(tagId+' is not a number');
                } else {
                    this.tags.push(tagId);
                }
            },

            detachTag(tagId) {
                let index = this.tags.indexOf(tagId);
                this.tags.splice(index, 1);
            },


            /**
             * Get additional data
             * */

            getJobs(){
                // Display available jobs
                this.axiosGet('admin/app/jobs').then(response => {

                    const jobOptionsArray = response.data.map(({
                      job: value,
                      ...rest
                    }) => ({
                      value,
                      ...rest
                    }));

                    this.jobOptions = jobOptionsArray;

                }).catch(({response}) => {
                }).finally(() => {
                    this.finishedGetJob = true;
                });
            },

            getCandidates(){
                // Display available candidates
                this.axiosGet('admin/app/candidates?filter_with_status=3&per_page=5000').then(response => {

                    const candidateOptionsArray = response.data.data.map(({
                      fullname: value,
                      ...rest
                    }) => ({
                      value,
                      ...rest
                    }));
                    this.candidateOptions = candidateOptionsArray;

                }).catch(({response}) => {
                }).finally(() => {
                    this.finishedGetCandidate = true;

                });
            },

            getAttandees(){
                // Display atendees of course/quiz/feedback
                if(this.finishedGetData){
                    let selectedAtendees = {
                        status: 3,
                        job: JSON.stringify(this.inputs.job_id),
                        id: JSON.stringify(this.inputs.candidate_id),
                        tag: this.finishedGetTag ? JSON.stringify(this.tags) : this.inputs.tag_id,
                        per_page: 5000
                    };

                    this.axiosGet('admin/app/attendees', {
                        params: selectedAtendees
                    }).then(response => {

                        this.atendeeOptions = response.data;

                    }).catch(({response}) => {
                    }).finally(() => {
                    });
                }
            },

            getTags(){
                // Display available tags
                this.axiosGet('admin/app/tags').then(response => {

                    const tagOptionsArray = response.data.data.map(({
                      name: value,
                      ...rest
                    }) => ({
                      value,
                      ...rest
                    }));

                    this.tagOptions = tagOptionsArray;

                }).catch(({response}) => {
                }).finally(() => {
                    this.finishedGetTag= true;
                });
            },

            getFinishedStats() {
                // Display stats of finished vs unfinished courses by candidates
                let url = 'admin/app/candidates-stats', reqData = {};

                reqData.params = {
                    status: 2,
                };

                this.axiosGet(url, reqData).then(response => {

                    this.finishedStats = response.data;

                }).catch(({response}) => {

                }).finally(() => {
                    this.isActiveFinishedStats = true;
                });
            },

            getLastFormId() {
                // Get last form Id on submit and replace temporary one used for upload
                if(this.selectedUrl === ''){
                    this.axiosGet('admin/app/last-course').then(response => {

                    if (response.data) {
                        this.afterGetLastCourse(response.data);
                    }

                    }).finally(() => {
                    });
                }
            },

            afterGetLastCourse(course){
                // Get last form Id on submit and replace temporary one used for upload
                if(this.temporaryId != "0"){
                    this.axiosPost({
                        url: 'files/resolve-temporary-course',
                        data: {"temp":parseInt(this.temporaryId), "last":course.id}
                    }).then(response => {

                    }).finally(() => {
                    });
                }

            },


            /**
             * Save basic data
             */

            submit() {
                // Bugfix: at lze po vytvoreni formular pak zpetne editovat vse vcetne stitku
                if (this.tags.length !== 0){
                    this.inputs.tag_id = this.tags;
                }
                if(!this.selectedUrl){
                    this.inputs.tag_id = JSON.stringify(this.tags);
                    this.inputs.job_id = JSON.stringify(this.inputs.job_id);
                    this.inputs.candidate_id = JSON.stringify(this.inputs.candidate_id);
                }


                // Delete dealine months if timeline_state within trial period set instead
                if(this.inputs.timeline_state <= 12){
                    this.inputs.deadline_month = "";
                }


                this.save(this.inputs);

            },

            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
                this.getLastFormId();
            },

            afterError(res) {
                this.$toastr.e(res.data.message);

            },
            clear() {
                this.inputs = {};
            },


            /**
             * Load basic data
             */

            afterSuccessFromGetEditData(response) {

                // Handle tags
                if (response.data.tag_id) this.tag = response.data.tag_id;
                if (response.data.tag_id) {
                    let added_tags = JSON.parse(response.data.tag_id);

                    var _this = this;
                    added_tags.forEach(function(entry) {
                        _this.attachTag(parseInt(entry));
                    });

                }

                // Handle inputs
                this.inputs = response.data;

                this.inputs.answer_text_1 = 'Dokáže MS Excel vytvořit animované grafy?';
                this.inputs.answer_text_2 = 'Lze spravovat jednu tabulku na více listech?';
                this.inputs.answer_text_3 = 'Funkce MIN slouží k řazení výsledků';

                this.inputs.answer_1 = 0;
                this.inputs.answer_2 = 0;
                this.inputs.answer_3 = 0;

                // Load available jobs
                if(response.data.job_id){
                    let allJobs = JSON.parse(response.data.job_id);
                    let selectedJobs = [];

                    var _this = this;
                    allJobs.forEach(function(entry) {
                        selectedJobs.push(parseInt(entry));
                    });
                    this.inputs.job_id = selectedJobs;
                }

                // Load available candidates
                if(response.data.candidate_id){
                    let allCandidates = JSON.parse(response.data.candidate_id);
                    let selectedCandidates = [];

                    allCandidates.forEach(function(entry) {
                        selectedCandidates.push(parseInt(entry));
                    });
                    this.inputs.candidate_id = selectedCandidates;
                }


                this.inputs.body = response.data.body;

                this.preloader = false;
                this.finishedGetData = true;
                this.getAttandees();

                // Add visited candidate to history
                if (history.replaceState && location.href.indexOf("?course") <= 0) {
                    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?course='+this.inputs.id;
                    window.history.replaceState({path:newurl},'',newurl);
                }
            },



        },
    }
</script>
